import './App.css';
import Footer from './components/Footer';
import Home from './components/Home';

function App() {
  return (
    <div className="relative w-full h-full">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/images/background.png')" }}
      ></div>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative z-10">
        <Home />
        <Footer />
      </div>
    </div>
  );
}

export default App;
